import PreLaunchDetail from './PreLaunchDetail';

export default PreLaunchDetail;
